import { NgModule } from 'ng-metadata/core';
import { HeroDirective } from './hero.directive';
import { PopupDirective } from './popup.directive';
import { StickyDirective } from './sticky.directive';
import { AuthOpenDirective } from './auth-open.directive';
import { HowItWorksOpenDirective } from './hiw-open.directive';
import { GuaranteeOpenDirective } from './guarantee-open.directive';
import { ScrollIntoViewDirective } from './scroll-into-view.directive';
import { AutoFocusDirective } from './auto-focus.directive';

@NgModule({
  declarations: [
    HeroDirective,
    PopupDirective,
    StickyDirective,
    AuthOpenDirective,
    GuaranteeOpenDirective,
    HowItWorksOpenDirective,
    ScrollIntoViewDirective,
    AutoFocusDirective,
  ],
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/directives/directives.module.ts